module.exports = __webpack_public_path__ + "media/images/flags/fm-1c37b533c26e19b0e0c67c0909eb68eb.svg";